//ios弹动 || 遮罩穿透 处理
export class enableScroll{
    constructor(option){
        this.node = option.el;
        this.parentNode = option.el.parentNode;
        this.isScroll = false;
        this.x = 0;
        this.y = 0;
        this.mx= 0;
        this.my= 0;

        this.parentNodetouch();
        this.nodetouch();
    }

    stopScoll(e){
        e.preventDefault();
    }

    scrollDirection(x,y,mx,my){

        if(y-my>=0)return "down";

        return "up"

    }

    nodetouch(){
        let move = e=>{
                this.mx = e.touches[0].pageX;
                this.my =  e.touches[0].pageY;

                let direction = this.scrollDirection(this.x,this.y,this.mx,this.my);

                let scrollTop = this.node.scrollTop,
                    scrollHeight = this.node.scrollHeight,
                    nodeHeight = this.node.clientHeight;

                if((scrollTop===0 && direction=='up') || ((scrollHeight - nodeHeight - scrollTop === 0 ) && direction=='down')){
                    e.preventDefault();
                    this.isScroll = false;
                }else{
                    e.stopPropagation();
                    this.isScroll = true;
                }
            },
            start = e=>{
                this.x = e.touches[0].pageX;
                this.y =  e.touches[0].pageY;
            };

        this.node.addEventListener('touchstart',start,false);
        this.node.addEventListener('touchmove',move,false);
    }

    parentNodetouch(){
        let move = e=>{
                if(!this.isScroll)this.stopScoll(e);
            },
            start = e=>{
                this.isScroll = false;
            };

        this.parentNode.addEventListener('touchstart',start,false);
        this.parentNode.addEventListener('touchmove',move,false);
    }
}